import request from '@/utils/request'
export const getSharingGrowth = params => request({ url: '/admin/sharing-growth', method: 'GET', params })
export const getSharingRecords = params => request({ url: '/admin/sharing-growth/shares', method: 'GET', params })
export const getSharingConversions = params => request({ url: '/admin/sharing-growth/conversions', method: 'GET', params })
